module.exports = __webpack_public_path__ + "media/src/images/corporation-not-image-2bf7f8cdf7bac4575a6d29cc92585a83.png";